// extracted by mini-css-extract-plugin
export default {"dialogmainwrapper":"dialogActiveInactiveEntity_dialogmainwrapper__EAYUx","btns":"dialogActiveInactiveEntity_btns__IRzCd"};